import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { patch, removeItem, updateItem } from '@ngxs/store/operators';
import { UtilityService } from 'src/app/core/services/utility.service';
import { ToggleHide } from 'src/app/shared/ui/spinner/redux/spinner.actions';
import { SurveysStateModel } from './surveys-state.model';
import {
  DeleteSurveys,
  LoadSurveys,
  LoadSurveysSuccess,
  PostSurveys,
  ReloadSurveys,
  ReloadSurveysSuccess,
  SaveSurveysComplete,
  SaveSurveysFail
} from './surveys.actions';
import { SurveyService } from '../services/survey.service';

@State<SurveysStateModel>({
  name: 'surveys',
  defaults: {
    surveys: undefined,
    error: null
  }
})
@Injectable()
export class SurveysState {
  constructor(
    private service: SurveyService,
    private toastrService: NbToastrService,
    private utilityService: UtilityService
  ) {}

  @Selector()
  public static surveys(state: SurveysStateModel) {
    return state.surveys;
  }

  @Action(LoadSurveys)
  public async loadSurveys() {
    this.service.loadSurveysAmplify();
  }

  @Action(LoadSurveysSuccess)
  public loadSurveysSuccess(ctx: StateContext<SurveysStateModel>, { payload }: any) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      surveys: payload.surveys.slice().sort((a, b) => a.survey_id.localeCompare(b.survey_id))
    });
    ctx.dispatch(ToggleHide);
  }

  @Action(ReloadSurveys)
  public async reloadSurveys() {
    this.toastrService.show(status, 'Fetch Initiated', { status: 'info' });
    this.service.loadSurveysAmplify(true);
  }

  @Action(ReloadSurveysSuccess)
  public reloadSurveysSuccess(ctx: StateContext<SurveysStateModel>, { payload }: any) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      surveys: payload
    });
  }

  @Action(PostSurveys)
  public async postSurveys(_ctx: StateContext<SurveysStateModel>, { payload, edit }: any) {
    this.service.postSurveysAmplify(payload, edit);
  }

  @Action(DeleteSurveys)
  public deleteSurveys(_ctx: StateContext<SurveysStateModel>, { payload, edit }: any) {
    this.service.postSurveysAmplify(payload, edit);
  }

  @Action(SaveSurveysComplete)
  public surveysComplete(ctx: StateContext<SurveysStateModel>, { data, survey, edit }: any) {
    const state = ctx.getState();

    if (data.errorMessage) {
      ctx.dispatch(new SaveSurveysFail(data));

      return;
    }
    if (edit === true) {
      if (survey.deleted) {
        ctx.setState(
          patch({
            surveys: removeItem((item) => item.survey_id === survey.survey_id)
          })
        );
        this.toastrService.show(status, 'Delete: Complete', { status: 'success' });

        return;
      } else {
        ctx.setState(
          patch({
            surveys: updateItem((item) => item.survey_id === survey.survey_id, survey)
          })
        );
        this.toastrService.show(status, 'Update: Complete', { status: 'success' });

        return;
      }
    }
    if (edit === false) {
      ctx.setState(
        patch({
          surveys: [...state.surveys, data]
        })
      );
      this.toastrService.show(status, 'Save: Complete', { status: 'success' });

      return;
    }
  }

  @Action(SaveSurveysFail)
  public surveysFail(ctx: StateContext<SurveysStateModel>, { payload }: any) {
    const state = ctx.getState();
    const error = this.utilityService.convertErrorToMessage(payload);
    ctx.setState({
      ...state,
      error
    });
    if (error) {
      this.toastrService.show(status, 'Save: Fail -' + error, { status: 'danger' });
    }
  }
}
